"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("components");
const config_1 = require("config");
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const hooks_1 = require("hooks");
const utils_1 = require("utils");
const actions_1 = require("../actions");
const reducer_1 = require("../reducer");
function ImprintIDV({ offer }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_1.useHistory)();
    const personalInfo = (0, react_redux_1.useSelector)(reducer_1.selectors.personalInfo);
    const prequalification = (0, react_redux_1.useSelector)(reducer_1.selectors.prequalification);
    const handleRefreshOffer = (0, react_1.useCallback)(async () => {
        const res = await getCreditApplicationsByStatus({
            applicationId: prequalification?.applicationId,
        });
        if ('data' in res) {
            const { data } = res;
            const imprintOffer = data?.offers?.find((offer) => offer.serviceProviderName === 'Imprint');
            const otherOffers = data?.offers?.filter((offer) => offer.serviceProviderName !== 'Imprint' &&
                offer.offerType === 'prequalified');
            if (data?.applicationStatus === 'not_prequalified') {
                if (imprintOffer) {
                    history.push({
                        pathname: config_1.PRE_QUALIFICATION_DECLINED_IMPRINT_ONLY_URL,
                        state: { email: personalInfo.email, aanUrl: imprintOffer.aanUrl },
                    });
                }
                else {
                    history.push(config_1.PRE_QUALIFICATION_ACCEPT_DECLINED_URL);
                }
                return;
            }
            if (imprintOffer && imprintOffer.offerType !== 'step_up_pend') {
                dispatch((0, actions_1.setPrequalification)(data));
                dispatch((0, actions_1.setActiveOfferId)(imprintOffer.offerId));
                if (otherOffers && otherOffers.length > 0) {
                    dispatch((0, actions_1.setOfferScreen)('OTHER OFFERS'));
                }
                else {
                    dispatch((0, actions_1.setOfferScreen)('PRESENTED OFFER'));
                }
            }
            else {
                (0, utils_1.toastError)('Application status is still pending identity verification.');
            }
        }
    }, [dispatch, history, personalInfo.email, prequalification?.applicationId]);
    const { setNewTab, isAwaitingClose } = (0, hooks_1.useNewTab)(handleRefreshOffer);
    const [getCreditApplicationsByStatus, { isFetching }] = (0, consumer_applications_v2_api_1.useLazyGetConsumerApplicationsV2CreditApplicationsApplicationIdQuery)();
    const handleCompleteVerification = () => {
        const imprintIDVTab = window.open(offer.actionDetails?.url);
        setNewTab(imprintIDVTab);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.H1, { children: "You're almost done! We need additional information to generate your offer." }), (0, jsx_runtime_1.jsxs)(components_1.P, { variant: "title-large", className: "mar-t-24", children: ["Please click COMPLETE VERIFICATION below in order to provide a US-government issued photo ID and selfie to complete the verification.", ' '] }), (0, jsx_runtime_1.jsx)(components_1.Button, { className: "button-warn-advantage mar-t-24 complete-verification", type: "button", onClick: handleCompleteVerification, submitting: isAwaitingClose || isFetching, invalid: isAwaitingClose || isFetching, children: "COMPLETE VERIFICATION" }), (0, jsx_runtime_1.jsx)(components_1.P, { variant: "title-large", className: "mar-t-24", children: "After successfully verifying your identity, you will be able to view your Alphaeon Advantage offer and continue with the pre-qualification process." }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex align-center mar-t-24", children: [(0, jsx_runtime_1.jsxs)(components_1.P, { variant: "title-large", className: "mar-right-10", children: ["Already completed the verification process?", ' '] }), !isFetching ? ((0, jsx_runtime_1.jsx)(components_1.P, { variant: "title-large", className: "text-as-link bold", onClick: () => {
                            !isFetching && handleRefreshOffer();
                        }, role: "button", tabIndex: 0, onKeyDown: (e) => {
                            if (e.key === 'Enter' && !isFetching) {
                                handleRefreshOffer();
                            }
                        }, children: "Click here to refresh your offer." })) : ((0, jsx_runtime_1.jsx)(components_1.Spinner, { size: "small" }))] })] }));
}
exports.default = ImprintIDV;
